/**
 * Catalog stock / sellability checks usable from API routes (no client-only imports).
 * Mirrors checkout cart rules in cartAvailability.ts.
 */

export type CatalogProductSnap = {
  active: boolean;
  unlimitedStock: boolean;
  stock: number;
  variants: Array<{ id: string; stock: number }>;
};

export type CatalogLineIssueCode =
  | 'ok'
  | 'removed'
  | 'inactive'
  | 'unavailable_variant'
  | 'out_of_stock'
  | 'insufficient_variant'
  | 'insufficient_product';

export function evaluateCatalogLine(
  snap: CatalogProductSnap | null,
  variantId: string | null | undefined,
  quantity: number
): CatalogLineIssueCode {
  if (snap === null) return 'removed';
  if (!snap.active) return 'inactive';
  if (snap.unlimitedStock) return 'ok';

  const variants = snap.variants ?? [];
  if (variants.length > 0) {
    if (variantId == null || variantId === '') return 'unavailable_variant';
    const v = variants.find((x) => x.id === variantId);
    if (!v) return 'unavailable_variant';
    if (v.stock < quantity) {
      return v.stock <= 0 ? 'out_of_stock' : 'insufficient_variant';
    }
    return 'ok';
  }

  if (snap.stock < quantity) {
    return snap.stock <= 0 ? 'out_of_stock' : 'insufficient_product';
  }
  return 'ok';
}

export function isCatalogLineSellable(
  snap: CatalogProductSnap | null,
  variantId: string | null | undefined,
  quantity: number
): boolean {
  return evaluateCatalogLine(snap, variantId, quantity) === 'ok';
}
